// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M3 5C3 2.79086 4.79086 1 7 1H21V23H7C4.79086 23 3 21.2091 3 19V5ZM10.0039 5H8V7.00391H10.0039V5ZM10.0039 8H8V10.0039H10.0039V8ZM7.5 16C6.11929 16 5 17.1193 5 18.5C5 19.8807 6.11929 21 7.5 21H19V16H12L12 19.75L10 18.4049L8 19.75L8 16H7.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-git-repository-filled')
export default class GitRepositoryFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'git-repository-filled',
    }
  }
}
